import { CoreStore } from '../store/core.store';
import { getRouterInitialUrl, getRouterInitialUrlActivated } from '../store/router/router.selectors';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import type { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class InitialPageGuardService  {

  constructor(
    private store: CoreStore,
    private router: Router
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const initialUrl = this.store.get(getRouterInitialUrl);
    const initialUrlActivated = this.store.get(getRouterInitialUrlActivated);
    if (!initialUrlActivated && initialUrl) {
      this.store.dispatch('Router_SetInitialUrlActivated', true);
      return this.router.createUrlTree([initialUrl]);
    }
    return true;
  }
}
